'use client';

type Props = {
  gtmApiKey: string;
  userId?: string;
};

/**
 * Note: GTM is loaded unconditionally in layout.tsx so Google Consent Mode v2
 * can observe it from the start. All storage defaults to denied; CookieYes
 * calls gtag('consent', 'update', ...) when the user makes a selection.
 */
export default function CookieConsentManager({
  gtmApiKey: _gtmApiKey,
  userId: _userId
}: Props) {
  // As things that need to be gated are added they will be included in this file
  return null;
}
